/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  RequestApproveUserRequestWrapper,
  RequestCheckDuplicateEmailAddressRequest,
  RequestCheckSellerIdRequest,
  RequestCreateMstUsersRequest,
  RequestDeleteUserRequestWrapper,
  RequestGetConnectLwasStautsRequest,
  RequestGetSyncItemsStautsRequest,
  RequestGetUserListRequest,
  RequestGetUserSearchOptionsRequest,
  RequestLoginRequest,
  RequestLogoutRequest,
  RequestPasswordReset,
  RequestResetSyncItemsRequest,
  RequestUpdateAmazonInfoRequest,
  RequestUpdatePersonalUserInfoRequest,
  RequestUpdateUserRequest,
  ResponseCreateMstUserResponse,
  ResponseGetUserListResonse,
  ResponseLoginResponse,
  ResponseSyncItemsStatusResponse,
  ResponseUserSearchOptionsResponse,
} from '../models/index';
import {
    RequestApproveUserRequestWrapperFromJSON,
    RequestApproveUserRequestWrapperToJSON,
    RequestCheckDuplicateEmailAddressRequestFromJSON,
    RequestCheckDuplicateEmailAddressRequestToJSON,
    RequestCheckSellerIdRequestFromJSON,
    RequestCheckSellerIdRequestToJSON,
    RequestCreateMstUsersRequestFromJSON,
    RequestCreateMstUsersRequestToJSON,
    RequestDeleteUserRequestWrapperFromJSON,
    RequestDeleteUserRequestWrapperToJSON,
    RequestGetConnectLwasStautsRequestFromJSON,
    RequestGetConnectLwasStautsRequestToJSON,
    RequestGetSyncItemsStautsRequestFromJSON,
    RequestGetSyncItemsStautsRequestToJSON,
    RequestGetUserListRequestFromJSON,
    RequestGetUserListRequestToJSON,
    RequestGetUserSearchOptionsRequestFromJSON,
    RequestGetUserSearchOptionsRequestToJSON,
    RequestLoginRequestFromJSON,
    RequestLoginRequestToJSON,
    RequestLogoutRequestFromJSON,
    RequestLogoutRequestToJSON,
    RequestPasswordResetFromJSON,
    RequestPasswordResetToJSON,
    RequestResetSyncItemsRequestFromJSON,
    RequestResetSyncItemsRequestToJSON,
    RequestUpdateAmazonInfoRequestFromJSON,
    RequestUpdateAmazonInfoRequestToJSON,
    RequestUpdatePersonalUserInfoRequestFromJSON,
    RequestUpdatePersonalUserInfoRequestToJSON,
    RequestUpdateUserRequestFromJSON,
    RequestUpdateUserRequestToJSON,
    ResponseCreateMstUserResponseFromJSON,
    ResponseCreateMstUserResponseToJSON,
    ResponseGetUserListResonseFromJSON,
    ResponseGetUserListResonseToJSON,
    ResponseLoginResponseFromJSON,
    ResponseLoginResponseToJSON,
    ResponseSyncItemsStatusResponseFromJSON,
    ResponseSyncItemsStatusResponseToJSON,
    ResponseUserSearchOptionsResponseFromJSON,
    ResponseUserSearchOptionsResponseToJSON,
} from '../models/index';

export interface UsersApproveUserPostRequest {
    wrapperReq: RequestApproveUserRequestWrapper;
}

export interface UsersCheckDuplicateMailAddressPostRequest {
    req: RequestCheckDuplicateEmailAddressRequest;
}

export interface UsersCheckSellerIdPostRequest {
    req: RequestCheckSellerIdRequest;
}

export interface UsersCreateUserPostRequest {
    user: RequestCreateMstUsersRequest;
}

export interface UsersDeleteUserPostRequest {
    wrapperReq: RequestDeleteUserRequestWrapper;
}

export interface UsersGetConnectLwaStatusPostRequest {
    req: RequestGetConnectLwasStautsRequest;
}

export interface UsersGetSyncItemsStatusPostRequest {
    req: RequestGetSyncItemsStautsRequest;
}

export interface UsersGetUserListPostRequest {
    req: RequestGetUserListRequest;
}

export interface UsersLoginPostRequest {
    login: RequestLoginRequest;
}

export interface UsersLogoutPostRequest {
    req: RequestLogoutRequest;
}

export interface UsersPasswordResetPostRequest {
    req: RequestPasswordReset;
}

export interface UsersResetSyncItemsPostRequest {
    req: RequestResetSyncItemsRequest;
}

export interface UsersSearchOptionsPostRequest {
    req: RequestGetUserSearchOptionsRequest;
}

export interface UsersUpdateAmazonInfoPostRequest {
    req: RequestUpdateAmazonInfoRequest;
}

export interface UsersUpdatePersonalUserInfoPostRequest {
    req: RequestUpdatePersonalUserInfoRequest;
}

export interface UsersUpdateUserPostRequest {
    req: RequestUpdateUserRequest;
}

/**
 * 
 */
export class UsersApi extends runtime.BaseAPI {

    /**
     * ユーザー承認
     * ユーザー承認
     */
    async usersApproveUserPostRaw(requestParameters: UsersApproveUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['wrapperReq'] == null) {
            throw new runtime.RequiredError(
                'wrapperReq',
                'Required parameter "wrapperReq" was null or undefined when calling usersApproveUserPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/ApproveUser`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestApproveUserRequestWrapperToJSON(requestParameters['wrapperReq']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * ユーザー承認
     * ユーザー承認
     */
    async usersApproveUserPost(requestParameters: UsersApproveUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.usersApproveUserPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メールアドレスが登録されているかチェック
     * メールアドレスが登録されているかチェック
     */
    async usersCheckDuplicateMailAddressPostRaw(requestParameters: UsersCheckDuplicateMailAddressPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling usersCheckDuplicateMailAddressPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/checkDuplicateMailAddress`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestCheckDuplicateEmailAddressRequestToJSON(requestParameters['req']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * メールアドレスが登録されているかチェック
     * メールアドレスが登録されているかチェック
     */
    async usersCheckDuplicateMailAddressPost(requestParameters: UsersCheckDuplicateMailAddressPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.usersCheckDuplicateMailAddressPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * セラーＩＤが設定されているかチェック
     * セラーＩＤが設定されているかチェック
     */
    async usersCheckSellerIdPostRaw(requestParameters: UsersCheckSellerIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling usersCheckSellerIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/checkSellerId`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestCheckSellerIdRequestToJSON(requestParameters['req']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * セラーＩＤが設定されているかチェック
     * セラーＩＤが設定されているかチェック
     */
    async usersCheckSellerIdPost(requestParameters: UsersCheckSellerIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.usersCheckSellerIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 新しいユーザーを登録する
     * 新しいユーザーを登録
     */
    async usersCreateUserPostRaw(requestParameters: UsersCreateUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseCreateMstUserResponse>> {
        if (requestParameters['user'] == null) {
            throw new runtime.RequiredError(
                'user',
                'Required parameter "user" was null or undefined when calling usersCreateUserPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/createUser`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestCreateMstUsersRequestToJSON(requestParameters['user']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseCreateMstUserResponseFromJSON(jsonValue));
    }

    /**
     * 新しいユーザーを登録する
     * 新しいユーザーを登録
     */
    async usersCreateUserPost(requestParameters: UsersCreateUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseCreateMstUserResponse> {
        const response = await this.usersCreateUserPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ユーザー情報を論理削除
     * ユーザー情報を論理削除
     */
    async usersDeleteUserPostRaw(requestParameters: UsersDeleteUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['wrapperReq'] == null) {
            throw new runtime.RequiredError(
                'wrapperReq',
                'Required parameter "wrapperReq" was null or undefined when calling usersDeleteUserPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/DeleteUser`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestDeleteUserRequestWrapperToJSON(requestParameters['wrapperReq']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * ユーザー情報を論理削除
     * ユーザー情報を論理削除
     */
    async usersDeleteUserPost(requestParameters: UsersDeleteUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.usersDeleteUserPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * LWA連携状態フラグ取得
     * LWA連携状態フラグ取得
     */
    async usersGetConnectLwaStatusPostRaw(requestParameters: UsersGetConnectLwaStatusPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling usersGetConnectLwaStatusPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/getConnectLwaStatus`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestGetConnectLwasStautsRequestToJSON(requestParameters['req']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * LWA連携状態フラグ取得
     * LWA連携状態フラグ取得
     */
    async usersGetConnectLwaStatusPost(requestParameters: UsersGetConnectLwaStatusPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.usersGetConnectLwaStatusPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * セラセン同期中かどうかと、直近の同期結果（取り込み件数・自己配送のため除外した件数・エラー内容）を返す
     * セラセン同期状態取得
     */
    async usersGetSyncItemsStatusPostRaw(requestParameters: UsersGetSyncItemsStatusPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseSyncItemsStatusResponse>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling usersGetSyncItemsStatusPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/getSyncItemsStatus`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestGetSyncItemsStautsRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseSyncItemsStatusResponseFromJSON(jsonValue));
    }

    /**
     * セラセン同期中かどうかと、直近の同期結果（取り込み件数・自己配送のため除外した件数・エラー内容）を返す
     * セラセン同期状態取得
     */
    async usersGetSyncItemsStatusPost(requestParameters: UsersGetSyncItemsStatusPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseSyncItemsStatusResponse> {
        const response = await this.usersGetSyncItemsStatusPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ユーザー情報 を取得
     * ユーザー情報 を取得
     */
    async usersGetUserListPostRaw(requestParameters: UsersGetUserListPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ResponseGetUserListResonse>>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling usersGetUserListPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/GetUserList`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestGetUserListRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ResponseGetUserListResonseFromJSON));
    }

    /**
     * ユーザー情報 を取得
     * ユーザー情報 を取得
     */
    async usersGetUserListPost(requestParameters: UsersGetUserListPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ResponseGetUserListResonse>> {
        const response = await this.usersGetUserListPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * テナントIDとメールアドレスとパスワードでログインします
     * ユーザーのログイン
     */
    async usersLoginPostRaw(requestParameters: UsersLoginPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLoginResponse>> {
        if (requestParameters['login'] == null) {
            throw new runtime.RequiredError(
                'login',
                'Required parameter "login" was null or undefined when calling usersLoginPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestLoginRequestToJSON(requestParameters['login']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLoginResponseFromJSON(jsonValue));
    }

    /**
     * テナントIDとメールアドレスとパスワードでログインします
     * ユーザーのログイン
     */
    async usersLoginPost(requestParameters: UsersLoginPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLoginResponse> {
        const response = await this.usersLoginPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * login_history_id に対応するレコードの logout_at を更新します
     * ユーザーのログアウト
     */
    async usersLogoutPostRaw(requestParameters: UsersLogoutPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: boolean; }>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling usersLogoutPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/logout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestLogoutRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * login_history_id に対応するレコードの logout_at を更新します
     * ユーザーのログアウト
     */
    async usersLogoutPost(requestParameters: UsersLogoutPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: boolean; }> {
        const response = await this.usersLogoutPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * パスワードリセット
     * パスワードリセット
     */
    async usersPasswordResetPostRaw(requestParameters: UsersPasswordResetPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling usersPasswordResetPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/passwordReset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestPasswordResetToJSON(requestParameters['req']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * パスワードリセット
     * パスワードリセット
     */
    async usersPasswordResetPost(requestParameters: UsersPasswordResetPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.usersPasswordResetPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 中断された同期により残った同期中フラグを解除する
     * セラセン同期中フラグ解除
     */
    async usersResetSyncItemsPostRaw(requestParameters: UsersResetSyncItemsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling usersResetSyncItemsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/resetSyncItems`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestResetSyncItemsRequestToJSON(requestParameters['req']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * 中断された同期により残った同期中フラグを解除する
     * セラセン同期中フラグ解除
     */
    async usersResetSyncItemsPost(requestParameters: UsersResetSyncItemsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.usersResetSyncItemsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ユーザー検索バーに表示するユーザー情報取得
     * UserSearch を取得
     */
    async usersSearchOptionsPostRaw(requestParameters: UsersSearchOptionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ResponseUserSearchOptionsResponse>>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling usersSearchOptionsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/searchOptions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestGetUserSearchOptionsRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ResponseUserSearchOptionsResponseFromJSON));
    }

    /**
     * ユーザー検索バーに表示するユーザー情報取得
     * UserSearch を取得
     */
    async usersSearchOptionsPost(requestParameters: UsersSearchOptionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ResponseUserSearchOptionsResponse>> {
        const response = await this.usersSearchOptionsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Amazon連携情報 を更新
     * Amazon連携情報 を更新
     */
    async usersUpdateAmazonInfoPostRaw(requestParameters: UsersUpdateAmazonInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling usersUpdateAmazonInfoPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/UpdateAmazonInfo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestUpdateAmazonInfoRequestToJSON(requestParameters['req']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Amazon連携情報 を更新
     * Amazon連携情報 を更新
     */
    async usersUpdateAmazonInfoPost(requestParameters: UsersUpdateAmazonInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.usersUpdateAmazonInfoPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ユーザー情報（個人で） を更新
     * ユーザー情報（個人で） を更新
     */
    async usersUpdatePersonalUserInfoPostRaw(requestParameters: UsersUpdatePersonalUserInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling usersUpdatePersonalUserInfoPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/UpdatePersonalUserInfo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestUpdatePersonalUserInfoRequestToJSON(requestParameters['req']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * ユーザー情報（個人で） を更新
     * ユーザー情報（個人で） を更新
     */
    async usersUpdatePersonalUserInfoPost(requestParameters: UsersUpdatePersonalUserInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.usersUpdatePersonalUserInfoPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ユーザー情報 を更新
     * ユーザー情報 を更新
     */
    async usersUpdateUserPostRaw(requestParameters: UsersUpdateUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling usersUpdateUserPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/UpdateUser`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestUpdateUserRequestToJSON(requestParameters['req']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * ユーザー情報 を更新
     * ユーザー情報 を更新
     */
    async usersUpdateUserPost(requestParameters: UsersUpdateUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.usersUpdateUserPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
